







import { Component, Prop, Vue } from 'vue-property-decorator';

import Icon from './icon.vue';

@Component({
  components: { Icon },
})
export default class Button extends Vue {
  @Prop({ default: () => ({}) })
  private mods!: Hash;

  @Prop({ default: () => 'mdi' })
  private iconNS!: string;

  @Prop({ default: (): string => null })
  private icon!: string;

  @Prop({ default: (): string => null })
  private label!: string;

  private blockName: string = 'button';

}
